
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.652","height":"23.652"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M11.826 0A11.826 11.826 0 110 11.826 11.826 11.826 0 0111.826 0z"}}),_c('path',{attrs:{"d":"M11.826 1c-2.892 0-5.61 1.126-7.655 3.17A10.755 10.755 0 001 11.827c0 2.892 1.126 5.61 3.17 7.655a10.755 10.755 0 007.656 3.171c2.892 0 5.61-1.126 7.655-3.17a10.755 10.755 0 003.171-7.656c0-2.892-1.126-5.61-3.17-7.655A10.755 10.755 0 0011.825 1m0-1c6.531 0 11.826 5.295 11.826 11.826 0 6.531-5.295 11.826-11.826 11.826C5.295 23.652 0 18.357 0 11.826 0 5.295 5.295 0 11.826 0z","fill":"#d6ddeb"}})]),_c('g',{attrs:{"transform":"translate(8.13 8.17)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('line',{attrs:{"y2":"7.453","transform":"translate(3.727)"}}),_c('line',{attrs:{"x1":"7.453","transform":"translate(0 3.727)"}})])])
          )
        }
      }
    